export default class FormController {
	constructor() {
		this.REQUIRED_FIELDS = [];
		this.form_data = {};
		this.form = $('#form');
		this.message = $('#message');
		this.init();
	}

	init() {
		this.form.submit((event) => {
			event.preventDefault();
			let elements = event.currentTarget.elements;
			for (let i = 0; i < elements.length; i++) {
				const element = elements[i];
				if (element.name.length > 0) {
					if (element.dataset.required === "true") {
						this.REQUIRED_FIELDS.push(element.name);
						this.form_data[element.name] = element.value;
					}
				}
			}
			console.log(this.REQUIRED_FIELDS)
			if (this.validate(event) === this.REQUIRED_FIELDS.length) {

				/* Ajax call */
			}
		});
	}

	validate() {
		this.REQUIRED_FIELDS.forEach(field => {
			if (this.form_data[field] < 1) {
				$('input[name="' + field + '"]').removeClass().addClass('form-control is-invalid');
			} else {
				$('input[name="' + field + '"]').removeClass().addClass('form-control is-valid');
				if (!this.checkEmail(this.form_data['email'])) {
					$('input[name="email"]').removeClass().addClass('form-control is-invalid');
				} else {
					$('input[name="email"]').removeClass().addClass('form-control is-valid');
				}
			}
		});
		let valid = 0;
		this.REQUIRED_FIELDS.forEach(field => {
			if ($('input[name="' + field + '"]').hasClass('is-valid')) {
				valid++;
			}
		});
		return valid;
	}

	checkEmail(email) {
		let regex = (/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
		return regex.test(email);
	}
}